import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {Box} from '@vio/atlas/src/components/designSystem/helpers/Box'
import {cssTheme} from '@vio/atlas/themes'

// Mirrors CardInner so the skeleton occupies the same footprint as a real card,
// avoiding layout shift when offers load in.
const SkeletonCardInner = styled.div`
  align-items: flex-start;
  align-self: stretch;
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  gap: ${cssTheme.layout.spacing.s600};
  height: 100%;
  justify-content: space-between;
  width: 100%;
`

export const HotelOfferCardSkeleton: React.FC = () => (
  <SkeletonCardInner data-id="APOfferCardSkeleton">
    {/* Provider logo + perks placeholder */}
    <div>
      <SkeletonLoader width={96} />
      <SkeletonLoader width={158} />
    </div>
    {/* Price + CTA placeholder */}
    <Box display="flex" flexDirection="column" gap="s600" width="100%">
      <div>
        <SkeletonLoader width={93} />
        <SkeletonLoader width={158} />
      </div>
      <SkeletonLoader marginTop={0} />
    </Box>
  </SkeletonCardInner>
)
